import { Collapse } from 'antd'
import cx from 'classnames'
import { ReactNode } from 'react'
import styled from 'styled-components'

const { Panel } = Collapse

type Props = {
  id: string
  children: ReactNode
  className?: string
  title: ReactNode
  defaultActiveKey?: string | string[]
  // Optional controlled pair: when a parent needs to force the panel open after
  // mount (e.g. in reaction to some other form state), pass activeKey + onChange.
  // Leaving both unset keeps the existing uncontrolled behavior driven by
  // defaultActiveKey — antd's Collapse treats activeKey === undefined as
  // "uncontrolled".
  activeKey?: string | string[]
  onChange?: (key: string | string[]) => void
  fontBold?: boolean
}

const StyledCollapse = styled(Panel)<{ fontBold: boolean }>`
  & > .ant-collapse-header {
    background-color: #f3f3f3;
    padding: 8px 16px !important;
    border-radius: 8px !important;
  }
  & .ant-collapse-header-text {
    font-weight: ${props => (props.fontBold ? 'bold' : 'normal')};
  }
`

export const AppCollapseSingleV2 = ({
  id,
  children,
  title,
  className,
  defaultActiveKey = null,
  activeKey,
  onChange,
  fontBold = true,
}: Props) => {
  return (
    <div className={cx([className, 'mt-4'])}>
      <Collapse
        defaultActiveKey={defaultActiveKey}
        activeKey={activeKey}
        onChange={onChange}
        expandIconPosition="right"
        bordered={false}
        ghost
      >
        <StyledCollapse fontBold={fontBold} header={title} key={id}>
          {children}
        </StyledCollapse>
      </Collapse>
    </div>
  )
}
